import { useI18n } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useState, useEffect } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function LanguageSwitcher() {
  const { language, changeLanguage } = useI18n();
  const [langs, setLangs] = useState([
    { code: "nl", name: "Nederlands", flag: "NL" },
    { code: "en", name: "English", flag: "EN" },
    { code: "fr", name: "Francais", flag: "FR" },
  ]);

  useEffect(() => {
    axios.get(`${API_URL}/api/translations/languages`)
      .then((r) => { if (r.data?.length > 0) setLangs(r.data.filter(l => l.active)); })
      .catch(() => {});
  }, []);

  const current = langs.find((l) => l.code === language) || langs[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-1.5" data-testid="language-switcher">
          <Globe className="w-4 h-4" />
          <span className="text-xs font-semibold">{current?.flag}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {langs.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={language === lang.code ? "bg-accent" : ""}
            data-testid={`lang-${lang.code}`}
          >
            <span className="font-semibold mr-2">{lang.flag}</span>
            {lang.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
